const bodies = new Map<string, Blob>();

/** Keeps local upload bytes without loading any product fixtures from the synchronous XHR guard. */
export function rememberDemoUploadBody(url: string, body: unknown) {
  if (body instanceof Blob) bodies.set(url, body);
}

/** Reads bytes previously captured by the demo XHR guard. */
export const demoUploadBody = (url: string) => bodies.get(url);

/** Discards bytes captured during this page's demo session. */
export const resetDemoUploadBodies = () => bodies.clear();
